import React from 'react';
import { SVGProps } from './types';

function UploadDocIcon(props: SVGProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M5.333 4.667h5.334M5.333 7.333H8"
      />
      <path
        stroke="currentColor"
        d="M13.406 10H9v4.289m4.667-4.29V1.34a.007.007 0 00-.007-.006H2.34a.007.007 0 00-.007.007v13.32c0 .004.003.007.007.007H9L13.667 10z"
      />
    </svg>
  );
}

export { UploadDocIcon };
